export default {
	title: "Choose Interests",
    back: 'Back',
	button: "Save",
    skip: 'Skip'
};
